var _defs, _g, _path, _path2, _polygon, _polygon2, _polygon3, _polygon4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeWidthWht(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 225.88 142.96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:#eaeaea;}.cls-3{fill:url(#linear-gradient);}.cls-4{fill:url(#linear-gradient-2);}.cls-5{fill:url(#linear-gradient-3);}.cls-6{fill:#59595b;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 190.33,
    y1: 11.35,
    x2: 225.88,
    y2: 11.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#dbdbdc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9e9e9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 11.01,
    y1: 65.95,
    x2: 216.07,
    y2: 65.95,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -8654.05,
    y1: -2658.57,
    x2: -8618.5,
    y2: -2658.57,
    gradientTransform: "translate(-8618.35 -2538.62) rotate(180)",
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "200.12 6.56 199.96 19.24 190.25 13.35 190.41 0.66 200.12 6.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "190.33 0.66 225.88 1.02 225.76 22.04 213.19 14.45 202.9 8.25 190.33 0.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "225.76 22.04 225.8 34.72 215.91 28.82 216.07 16.14 225.76 22.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "200.14 6.56 216.07 16.14 26.94 125.33 11.01 115.75 200.14 6.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "216.07 16.14 215.91 28.82 27.5 138.02 26.94 125.33 216.07 16.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "35.7 130.64 35.7 143.62 0 142.96 0.16 130.28 35.7 130.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "35.7 130.64 0.16 130.28 0.27 109.26 12.85 116.85 23.13 123.05 35.7 130.64"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M81.26,60.77a2.32,2.32,0,0,1,.56,1.75,6.72,6.72,0,0,1-1.15,3.81,9.68,9.68,0,0,1-3.29,3L72.5,72.14l0-14.43,4.4-2.54c1.52-.88,2.68-1.21,3.47-1s1.18,1,1.19,2.26a5.46,5.46,0,0,1-.47,2.15,6.54,6.54,0,0,1-1.32,1.94A1.48,1.48,0,0,1,81.26,60.77Zm-2.54,4.89A2.91,2.91,0,0,0,79.23,64c0-1.32-.6-1.65-1.79-1l-2.37,1.37v3.89L77.3,67a4,4,0,0,0,1.42-1.32m-3.67-7v3.64L77,61.16a3.39,3.39,0,0,0,2-2.92c0-.66-.17-1-.5-1.13a2.38,2.38,0,0,0-1.57.47l-1.81,1.05"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M90.82,55.52l2.73,4.33V60l-2.77,1.6-2.37-3.92-2.07,1.19,0,5.28-2.59,1.5,0-14.44,4.67-2.69c1.48-.86,2.63-1.13,3.43-.84S93,48.8,93.05,50.19A7.05,7.05,0,0,1,92.5,53,9,9,0,0,1,90.82,55.52Zm-.89-1.71a3.55,3.55,0,0,0,.53-1.88q0-1-.51-1.32c-.33-.2-.85-.1-1.54.31l-2.08,1.2v4.33l2.09-1.2a4.24,4.24,0,0,0,1.5-1.44"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "103.4 39.85 103.41 42.25 97.6 45.61 97.61 49.05 102.58 46.18 102.58 48.49 97.62 51.36 97.63 55.24 103.46 51.88 103.46 54.27 95.05 59.13 95.01 44.69 103.4 39.85"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "107.69 37.37 107.73 51.8 105.14 53.3 105.1 38.87 107.69 37.37"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "119.3 30.67 119.3 33.08 115.45 35.3 115.49 47.33 112.9 48.82 112.87 36.79 109.07 38.98 109.07 36.58 119.3 30.67"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "129.17 24.97 129.18 27.38 123.36 30.73 123.37 34.17 128.34 31.31 128.35 33.62 123.38 36.49 123.39 40.37 129.22 37 129.23 39.39 120.81 44.25 120.77 29.82 129.17 24.97"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeWidthWht);
export default __webpack_public_path__ + "static/media/de-width-wht.b1efbc96a3fe0e9454b81fffc6390b50.svg";
export { ForwardRef as ReactComponent };